import React, { useContext, useEffect, useState } from 'react';
import { useProfileData } from '../../NecttosComp/APICaller/queryHooks';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { getIsCall } from '../../NecttosComp/APICaller/ApiServices';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import VerificationStudent from './VerificationStudent'
import TimerFunction from './TimerFunction';

function CallCandidate({
    userId,
    isStudent,
    keyData,
    stateData,
    onClose,
    handleStartTimer,
    setStateData,
    itemsDataData,
    setItemsDataData,
    startDateTimer,
    TimerFunction,
    parentOnClose,
}) {
    const { data: userDetail } = useProfileData(userId, !isStudent);
    const { collegeId } = useContext(FirebaseContext);

    const { data, refetch } = useQuery(['getAdmissionValidator', collegeId, userId], getIsCall(collegeId, userId));

    const [state, setState] = useState({ type: true });
    const [isRunning, setIsRunning] = useState(false);
    const [currentTime, setCurrentTime] = useState(30);
    const [callMessage, setCallMessage] = useState(false);


    const handleProceed = async () => {
        setIsRunning(true);
        setState({ ...state, callingNow: true });
        try {
            const instance = await getAxiosTokenInstance();
            const payload = {
                _id: userDetail?._id,
                type: state?.type,
                key: keyData,
            };
            const resp = await instance.post('/college/admissionProcess2/callStudentWithNotification', payload);
            if (resp.data.statusCode !== 200) {
                throw new Error(resp.data.message || 'API Error');
            }
        } catch (error) {
            console.log('CallStudentWithNotification Error:', error?.response?.data?.message || error?.message || 'API Error');
        }
    };

    const handleProceed2 = async () => {
        try {
            const instance = await getAxiosTokenInstance();
            const payload = {
                _id: userDetail?._id,
                type: false,
                key: keyData,
            };
            const resp = await instance.post('/college/admissionProcess2/callStudent', payload);
            if (resp.data.statusCode !== 200) {
                throw new Error(resp.data.message || 'API Error');
            }
        } catch (error) {
            console.log('CallStudent Error:', error?.response?.data?.message || error?.message || 'API Error');
        }
    };

    useEffect(() => {
        let interval = null;
        if (isRunning) {
            interval = setInterval(() => {
                setCurrentTime((prev) => prev - 1);
            }, 1000);
            if (currentTime < 28 && data?.verification) {
                if (!data.verification[keyData + 'Call']) {
                    setState({ ...state, callingNow: false });
                    setCallMessage(data.verification[keyData + 'CallMessage']);
                    if (currentTime > 1) setCurrentTime(1);

                    if (currentTime === 0) {
                        setIsRunning(false);
                        if (data.verification[keyData + 'CallMessage'] === 'Comming') {
                            handleStartTimer();
                            if (keyData === 'fees') setItemsDataData({ ...itemsDataData, feesBilling: true, studentId: data._id });
                            if (keyData === 'pta') setItemsDataData({ ...itemsDataData, feesBilling: true, keyDataIsStaff: true, studentId: data._id });

                            setStateData({
                                ...stateData,
                                callToken: false,
                                ...(['fees', 'office'].includes(keyData) && { grand: true }),
                                ...(!['pta', 'fees'].includes(keyData) && { viewMode: true }),
                            });
                        } else {
                            setCallMessage(false);
                            setCurrentTime(30);
                            setStateData({ ...stateData, callToken: false });
                        }
                    }
                }
            }
            refetch();
        }
        if (currentTime === 0) {
            setCallMessage(false);
            setCurrentTime(30);
            handleProceed2();
            setIsRunning(false);
        }
        return () => clearInterval(interval);
    }, [isRunning, currentTime, data]);


    if (!userId) {
        return (
            <div>
                <div>Select A User First</div>
            </div>
        );
    }

    const handleVerify = () => {
        setState({ ...state, verificationStudent: true });
    };

    const memberData = userDetail;

    return (
        <Main height='100%' width='90%' title='Call Candidate'>
            <Header>
                <div></div>
                <div className='flex justify-end'>
                    <Button type='close' onClick={parentOnClose}>
                        close
                    </Button>
                </div>
            </Header>
            <Body>
                <div className="flex flex-col items-center justify-center h-full overflow-auto px-4 py-6 dark:bg-slate-900 bg-slate-100 transition-colors duration-300">
                    <TimerFunction
                        start={true}
                        date={startDateTimer}
                        className="text-xl font-mono w-[28%] text-center rounded-lg p-3 ml-1 mb-4 h-[40px] flex justify-center items-center  dark:bg-neutral-700 dark:text-slate-100   bg-slate-100 text-slate-800"
                    />
                    <div className="flex flex-col items-center w-full max-w-sm p-6 rounded-2xl shadow-xl backdrop-blur-md bg-white/80 dark:bg-slate-800/60 transition-all duration-300">
                        <p className="text-sm text-green-600 dark:text-green-400 font-semibold mb-2 animate-pulse">
                            Calling...
                        </p>
                        <div className="relative w-36 h-36 rounded-full overflow-hidden shadow-lg mb-4">
                            <img
                                src={memberData?.photoURL || '/default-profile.png'}
                                alt="Member"
                                className="w-full h-full object-cover"
                            />
                        </div>


                        <div className="text-center mb-4">
                            <h5 className="text-lg font-bold text-slate-800 dark:text-slate-100">{memberData?.name}</h5>
                            {['office', 'fees', 'principa'].includes(keyData) && (
                                <p className="text-xs text-slate-600 dark:text-slate-300">
                                    Admission No: {memberData?.admisionNo}
                                </p>
                            )}
                        </div>


                        <div className="flex flex-col gap-2 w-full">
                            <button
                                onClick={handleVerify}
                                className="flex items-center justify-center gap-2 py-2 px-4 rounded-lg bg-blue-500 hover:bg-blue-600 text-white font-medium transition shadow-md"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                                </svg>
                                Continue
                            </button>

                            <button
                                onClick={onClose}
                                className="flex items-center justify-center gap-2 py-2 px-4 rounded-lg bg-red-500 hover:bg-red-600 text-white font-medium transition shadow-md"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </Body>

            {
                state?.verificationStudent && (
                    <VerificationStudent
                        userId={userId}
                        isStudent={true}
                        keyData={keyData}
                        handleStartTimer={handleStartTimer}
                        startDateTimer={state.dateTimer}
                        TimerFunction={TimerFunction}
                        stateData={state}
                        setStateData={setState}
                        parentOnClose={onClose}
                        onClose={() => {
                            setState({ ...state, verificationStudent: false });
                        }}
                    />

                )
            }
        </Main>
    );


}

export default CallCandidate;
